/**
 * Debug tags for planner module logging
 * Use with logger.debug(TAG, message, data)
 *
 * Tag is automatically disabled by default in src/utils/logger/logger.ts
 */
export const PLANNER_PAGINATION_LOG_TAG = 'PlannerPagination:';

/**
 * Logs the planner data snapshot pushed into the store (rows / assignment rows /
 * time-off rows) plus per-row warnings when a rendered row has no assignments while
 * the store actually holds some. Enable to debug "assignments missing after vertical
 * pagination" reports.
 */
export const PLANNER_DATA_LOG_TAG = 'PlannerData:';
